import { isDev } from 'lib/env';

export const devLog = (...messages: unknown[]) => {
  if (isDev) {
    console.log(...messages);
  }
};
